import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const bookingId = params.get("booking_id");
  const directPaid = params.get("paid") === "1"; // Razorpay flow
  const [state, setState] = useState(directPaid ? { status: "complete", payment: "paid" } : { status: "polling", payment: "pending" });
  const [attempts, setAttempts] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    if (directPaid) return; // Razorpay path — already verified server-side
    if (!sessionId) { setState({ status: "error", payment: "missing" }); return; }
    let cancelled = false;
    const poll = async (n) => {
      if (cancelled) return;
      if (n >= 10) { setState({ status: "timeout", payment: "pending" }); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState({ status: "complete", payment: "paid" }); return; }
        if (data.status === "expired") { setState({ status: "expired", payment: "failed" }); return; }
      } catch { /* keep polling */ }
      setAttempts(n + 1);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId, directPaid]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-10 paper" data-testid="payment-success-page">
      <div className="brut-card p-10 max-w-md text-center bg-[#FDFCF8]">
        {state.payment === "paid" ? (
          <>
            <div className="w-20 h-20 mx-auto brut-border bg-[#2ED573] flex items-center justify-center"><CheckCircle2 size={48}/></div>
            <h1 className="font-display font-black text-4xl mt-5">Payment Confirmed!</h1>
            <p className="text-[#4A4A4A] mt-2">Your booking is confirmed. The owner has been notified.</p>
            <div className="flex gap-2 mt-6 justify-center">
              <button className="brut-btn" onClick={()=>nav("/dashboard")} data-testid="go-dashboard-btn">Go to dashboard</button>
              {bookingId && <button className="brut-btn white" onClick={()=>nav("/dashboard")}>View booking</button>}
            </div>
          </>
        ) : state.status === "polling" ? (
          <>
            <Loader2 className="animate-spin mx-auto" size={48}/>
            <h1 className="font-display font-black text-3xl mt-4">Confirming payment...</h1>
            <p className="text-[#4A4A4A] mt-2">Attempt {attempts+1}/10. This usually takes a few seconds.</p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 mx-auto brut-border bg-[#FF90E8] flex items-center justify-center"><XCircle size={48}/></div>
            <h1 className="font-display font-black text-3xl mt-4">Payment {state.payment}</h1>
            <p className="text-[#4A4A4A] mt-2">If money was deducted, it'll be refunded in 5-7 days. You can retry from your dashboard.</p>
            <Link className="brut-btn mt-6 inline-flex" to="/dashboard">Go to dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
